import React, { useState, useEffect, useRef } from 'react';
import {
    List, Datagrid, TextField, SimpleList, Button as RaButton, useRefresh, usePermissions, FunctionField
} from 'react-admin';
import {
    useMediaQuery, makeStyles, Dialog, DialogContent, DialogActions, TextField as MuiTextField, Typography, Button, CircularProgress, FormControl, InputLabel, Select, MenuItem
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ParkingSearchSelector from "./components/ParkingSearchSelector";
import AddIcon from '@material-ui/icons/Add';
import config from "./config.json";
import * as CSV from 'csv-string';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import CustomSearch from './components/CustomSearch';
import CustomFilter from './components/CustomFilter';
import { useLocation } from 'react-router-dom';
import CustomExportButton from './components/CustomExportButton';
import CustomPagination from './components/CustomPagination';
import queryString from 'query-string';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';

const useStyles = makeStyles({
    list: {
        marginBottom: 40,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

export const CardTagsInventoryList = props => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const refresh = useRefresh();
    const { permissions } = usePermissions();
    const listDataRef = useRef();

    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));


    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Nfc ID", "Surface ID", "Batch ID"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Nfc ID");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [allocateDialogVisible, setAllocateDialogVisible] = useState(false);
    const [batchId, setBatchId] = useState("");
    const [parking, setParking] = useState(null);
    const [loading, setLoading] = useState(false);

    let filterTypesInitState = [
        {
            filterType: "Action",
            dataList: [{ name: "ISSUED", id: 2 }, { name: "NOT ISSUED", id: 3 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Allocation",
            dataList: [{ name: "Allocated", id: 1 }, { name: "Unallocated", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const renderAction = action => {
        var color;
        switch (action) {
            case "ISSUED": color = customTheme.palette.primary.main; break;
            case "NOT ISSUED": color = customTheme.palette.error.main; break;
            default: color = customTheme.palette.secondary.main;
        }

        return <div style={{ color }}>{action}</div>;
    }

    const onCsvUpload = event => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            if ((file.type === "application/vnd.ms-excel" && file.name.substr(-4) === ".csv") || file.type === "" || file.type === 'text/csv') {
                var reader = new FileReader();
                reader.onload = function (e) {
                    const csvData = CSV.parse(reader.result);
                    if (csvData.length === 0) {
                        notify("No Data in the file", "warning");
                        return;
                    }
                    if (csvData[0].length !== 3) {
                        notify("Incorrect number of columns in the csv", "warning");
                        return;
                    }

                    const params = {
                        user_id: sessionStorage.getItem("user_id"),
                        card_tags: csvData.slice(1)
                    };
                    fetch(`${config.HOST_NAME}/crm/v3/walletCardInventory`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                            'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
                        },
                        body: JSON.stringify(params)
                    })
                        .then(response => {
                            saveTokens(response)
                            return response.json()
                        })
                        .then(json => {
                            if (json.success) {
                                eventTracker("CARDS INVENTORY SECTION", "CARDS ADDED")
                                notify('Card Tags Added', "success");
                                refresh();
                            } else {
                                notify(json.message, "warning");
                            }
                        })
                        .catch(error => {
                            notify('Error adding Card Tags', 'warning');
                        });
                }
                reader.readAsText(file);
            } else {
                notify("Invalid File Format", "warning");
            }
        }
    };

    const closeAllocateDialog = () => {
        setAllocateDialogVisible(false);
    };

    const allocateTags = () => {
        if (batchId == null || batchId === "") {
            notify("Batch ID is Required", "warning");
            return;
        }
        // if (batchId.search(/^\d+$/g) === -1) {
        //     notify("Invalid Batch ID", "warning");
        //     return;
        // }
        if (parking == null && typeof parking !== "object") {
            notify("Parking is Required", "warning");
            return;
        }

        setLoading(true);
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            batch_id: batchId,
            access_key_id: parking.id
        };
        fetch(`${config.HOST_NAME}/crm/v3/cardTagsInventory/allocate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    closeAllocateDialog();
                    setBatchId("");
                    setParking(null);
                    eventTracker("CARDS INVENTORY SECTION", "CARDS ALLOCATED")
                    notify('Card Tags Allocated', "success");
                    refresh();
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch(error => {
                setLoading(false);
                notify('Error allocating Card Tags', 'warning');
            });
    };

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/cardsInventory?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : "Card Inventory"}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Action") {
                    values = { ...values, action: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Allocation") {
                    values = { ...settingFilterFormat, unallocated: filterListValue[val].value === "Allocated" ? false : filterListValue[val].value === "Unallocated" ? true : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        eventTracker("CARDS INVENTORY SECTION", " CARD LIST")
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            {!viewOnly && permissions === "admin" && <>
                <RaButton className='customCreateBtnStyle' title="Add" >
                    <>
                        <AddIcon style={{fontSize: 22}} />
                        <input type="file" accept=".csv" onChange={onCsvUpload} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "inherit" }} />
                    </>
                </RaButton>
                <RaButton className='customCreateBtnStyle' title="Allocate" onClick={() => setAllocateDialogVisible(true)}>
                    <AssignmentTurnedInOutlinedIcon style={{fontSize: 22}}/>
                </RaButton>
            </>}
            <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />
        </div>
        <List
            {...props}
            style={{marginTop: 20}}
            title="Card Tags Inventory"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
            actions={false}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => record["nfc_uid"]}
                    secondaryText={record => (<div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["surface_id"] ? `Tag ID: ${record["surface_id"]}` : ""}</div>
                        <div>{record["parking_name"] ? `Parking Name: ${record["parking_name"]}` : ""}</div>
                        <div>{record["issue_status"] ? `Status: ${record["issue_status"]}` : ""}</div>
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid component={ScrollableTable}>
                    <TextField source="nfc_uid" label="NFC UID" />
                    <TextField source="surface_id" label="TAG ID" />
                    <FunctionField source="issue_status" label="Status" render={record => record && renderAction(record["issue_status"])} />
                    <TextField source="batch_id" label="BATCH ID" />
                    <TextField source="parking_name" label="Parking Name" />
                </Datagrid>
            }
        </List>
        <Dialog fullWidth open={allocateDialogVisible} onClose={closeAllocateDialog}>
                <Typography style={{ fontSize: 19, fontWeight: "bold", padding: "16px 24px" }}>Allocate Tags</Typography>
                <DialogContent style={{ display: "grid", gridRowGap: 20 }}>
                    <MuiTextField
                        variant="outlined"
                        size="small"
                        label="Batch ID"
                        value={batchId}
                        onChange={(event) => {
                            // if (!isNaN(event.target.value))
                            setBatchId(event.target.value);
                        }}
                        maxLength={9}
                    />
                    <ParkingSearchSelector
                        value={parking}
                        onChange={setParking}
                        clearable={false}
                        zones={true}
                        size="small"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeAllocateDialog} disabled={loading}>Cancel</Button>
                    <Button color="primary" onClick={allocateTags} disabled={loading}>{loading ? "Allocating..." : "Allocate"} {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}</Button>
                </DialogActions>
            </Dialog>
    </div>
};